import gql from 'graphql-tag';

export const GRAPHQL_QUERY_BRANDS = gql`
    query brands($criteria:CriteriaInput){
        brands(criteria: $criteria){
            rows{
                id
                name
                createdAt
                isActive
                file{
                    id
                    token
                    filename
                }
                extraFile{
                    id
                    token
                    filename
                }
            }
            total
            id
        }
    }
`;

export const GRAPHQL_MUTATION_ADD_BRAND = gql`
    mutation addBrand($input: AddBrandInput!) {
        addBrand(brandInput: $input) {
            id
            name
            file{
                id
                bucket
                key
                filename
                mimeType
                encoding
                size
                createdAt
                updatedAt
            }
            extraFile{
                id
                bucket
                key
                filename
                mimeType
                encoding
                size
                createdAt
                updatedAt
            }
        }
    }
`;

export const GRAPHQL_MUTATION_UPDATE_BRAND = gql`
    mutation updateBrand($input: UpdateBrandInput!) {
        updateBrand(brandInput: $input) {
            id
            name
            isActive
            file{
                id
                bucket
                key
                filename
                mimeType
                encoding
                size
                createdAt
                updatedAt
            }
            extraFile{
                id
                bucket
                key
                filename
                mimeType
                encoding
                size
                createdAt
                updatedAt
            }
        }
    }
`;
